<div class="text-large font-medium margin-bottom-2">
    <a [routerLink]="'..'">{{ 'self-serve.payYourTeam.addYourTeam' | translate }}</a> /
    {{
        (isAddingTerminatedEmployee
            ? 'self-serve.payYourTeam.addTerminatedEmployees'
            : 'self-serve.payYourTeam.addEmployees'
        ) | translate
    }}
</div>

<!-- This banner doesn't conform to our normal banners -->
<!-- so I'm doing some work to make it look correct -->
<ui-banner *ngIf="isAddingTerminatedEmployee" class="margin-top-4 margin-bottom-6">
    <div class="banner-dont-touch">
        <!-- header -->
        <div class="flex margin-bottom-2">
            <mat-icon svgIcon="bulb" class="margin-right-1"></mat-icon>
            <strong>{{ 'self-serve.tips' | translate }}</strong>
        </div>
        <p class="margin-bottom-1">{{ 'self-serve.payYourTeam.addTerminatedEmployeeTip1' | translate }}</p>
        <p>{{ 'self-serve.payYourTeam.addTerminatedEmployeeTip2' | translate }}</p>
    </div>
</ui-banner>

<form invalidControlScroll #form="ngForm" [class.loading]="isLoading" (ngSubmit)="onSubmit()">
    <p class="large-header" *ngIf="isAddingTerminatedEmployee">
        {{ 'self-serve.payYourTeam.personalInformation' | translate }}
    </p>

    <app-segment-header
        [title]="
            isAddingTerminatedEmployee
                ? 'self-serve.payYourTeam.basicInformation'
                : 'self-serve.payYourTeam.personalInformation'
        "
    ></app-segment-header>

    <div class="responsive-grid">
        <div class="row">
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.firstName' | translate }}</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    name="firstName"
                    #firstName="ngModel"
                    [(ngModel)]="employee.firstName"
                />
                <mat-error *ngIf="firstName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.lastName' | translate }}</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    name="lastName"
                    #lastName="ngModel"
                    [(ngModel)]="employee.lastName"
                />
                <mat-error *ngIf="lastName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>
        </div>
        <mat-form-field>
            <mat-label>{{ 'self-serve.payYourTeam.email' | translate }}</mat-label>
            <input
                matInput
                type="text"
                name="email"
                placeholder="Eg: alex@company.com"
                #email="ngModel"
                [(ngModel)]="account.email"
                required
                emailValidator
            />
            <mat-error *ngIf="email.invalid">{{ email.errors | formErrors }}</mat-error>
        </mat-form-field>

        <ng-container *ngIf="!isAddingTerminatedEmployee">
            <ui-date-picker
                [label]="'self-serve.payYourTeam.hireDate' | translate"
                [(ngModel)]="employee.hiredAt"
                [required]="true"
                #hiredAt="ngModel"
                name="hiredAt"
            >
            </ui-date-picker>

            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{
                    'forms.applicant-tracker.hire-flow.position' | appTranslate
                }}</mat-label>
                <mat-select
                    placeholder="{{ 'forms.applicant-tracker.hire-flow.selectAPosition' | appTranslate }}"
                    required
                    [(ngModel)]="employee.job"
                    #position="ngModel"
                    [compareWith]="isSameModel"
                    name="position"
                >
                    <mat-option (click)="showCreateJobModal = true"
                        ><span class="add-option">{{
                            'forms.applicant-tracker.hire-flow.addNewPosition' | appTranslate
                        }}</span></mat-option
                    >
                    <mat-option *ngFor="let position of jobs" [value]="position">{{ position.title }}</mat-option>
                </mat-select>

                <mat-error *ngIf="position.invalid">{{ position.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{ 'self-serve.payYourTeam.office' | translate }}</mat-label>
                <mat-select
                    [disabled]="!offices.length"
                    required
                    name="employeeOffice"
                    #employeeOffice="ngModel"
                    [(ngModel)]="employee.officeId"
                    [placeholder]="'self-serve.payYourTeam.selectAnOption' | translate"
                >
                    <mat-option *ngFor="let office of offices" [value]="office.id">{{ office.name }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.submitted && employeeOffice.invalid">{{
                    'self-serve.fieldRequired' | translate
                }}</mat-error>
            </mat-form-field>
        </ng-container>
        <ng-container *ngIf="isAddingTerminatedEmployee">
            <ui-date-picker
                [label]="'self-serve.payYourTeam.dateOfBirth' | translate"
                [(ngModel)]="employee.bornOn"
                [required]="true"
                #bornOn="ngModel"
                name="bornOn"
                [minDate]="minBornOnDate"
                [maxDate]="maxBornOnDate"
            >
            </ui-date-picker>
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.sin' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    placeholder="123456789"
                    #sin="ngModel"
                    maxlength="9"
                    pattern="\d{9}"
                    required
                    name="sin"
                    [(ngModel)]="employee.sin"
                />
                <mat-error *ngIf="sin.invalid">{{ sin.errors | formErrors }}</mat-error>
            </mat-form-field>
        </ng-container>
    </div>

    <!-- compensation is only shown in its own group if adding a non-terminated employee -->
    <ng-container *ngIf="!isAddingTerminatedEmployee">
        <app-segment-header title="self-serve.payYourTeam.compensation"></app-segment-header>
        <div class="responsive-grid">
            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{ 'self-serve.payYourTeam.salaryFrequency' | translate }}</mat-label>
                <mat-select name="salaryFrequency" required #salaryFrequency="ngModel" [(ngModel)]="salary.frequency">
                    <mat-option *ngFor="let frequency of ['year', 'hour']" [value]="frequency">{{
                        'self-serve.' + frequency | translate
                    }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{ salary.frequencyLabel | translate }}</mat-label>
                <input
                    type="text"
                    matInput
                    [ngModel]="salary.rate"
                    (ngModelChange)="salary.rate = stripNonNumeric($event); resetCursorPosition()"
                    [textMask]="{ mask: currencyMask }"
                    [min]="0"
                    name="salary"
                    #salaryRate="ngModel"
                    required
                    [placeholder]="
                        'self-serve.payYourTeam.egAmount'
                            | translate: { amount: salary.frequency === 'hour' ? 30 : 45000 }
                    "
                />

                <mat-error *ngIf="salaryRate.invalid">{{ salaryRate.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{ 'self-serve.payYourTeam.employmentType' | translate }}</mat-label>
                <mat-select
                    required
                    #employmentType="ngModel"
                    name="employmentType"
                    placeholder="{{ 'self-serve.payYourTeam.selectAnEmploymentType' | translate }}"
                    [(ngModel)]="employee.employmentType"
                >
                    <mat-option *ngFor="let employmentType of employmentTypeValues" [value]="employmentType">{{
                        employmentTypeDisplay[employmentType] | translate | capitalize
                    }}</mat-option>
                </mat-select>

                <mat-error *ngIf="employmentType.invalid">{{ employmentType.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.hoursPerWeek' | translate }}</mat-label>
                <input
                    type="number"
                    [min]="0"
                    [max]="168"
                    placeholder="{{ 'self-serve.payYourTeam.eg40' | translate }}"
                    name="hoursPerWeek"
                    required
                    #hoursPerWeek="ngModel"
                    matInput
                    [(ngModel)]="salary.hoursPerWeek"
                />

                <mat-error *ngIf="hoursPerWeek.invalid">{{ hoursPerWeek.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <app-segment-header title="self-serve.payYourTeam.sendOnboardingInvite"></app-segment-header>
        <ui-banner class="margin-bottom-2" variant="info">
            <div>
                <p class="margin-bottom-2">
                    {{ 'self-serve.payYourTeam.sendOnboardingInviteDescription1' | translate }}
                </p>
                <p class="margin-bottom-2">
                    {{ 'self-serve.payYourTeam.sendOnboardingInviteDescription2' | translate }}
                </p>
                <p>{{ 'self-serve.payYourTeam.sendOnboardingInviteDescription3' | translate }}</p>
            </div>
        </ui-banner>

        <mat-checkbox
            class="margin-bottom-4"
            name="sendOutOnboardingInvite"
            [(ngModel)]="sendInvite"
            (click)="trackSelfServeOnboardingInviteCheckbox()"
            >{{ 'self-serve.payYourTeam.sendOutOnboardingInvite' | translate }}
        </mat-checkbox>
    </ng-container>

    <!-- we show the remainder for terminated employees -->
    <ng-container *ngIf="isAddingTerminatedEmployee">
        <app-segment-header title="self-serve.address"></app-segment-header>

        <app-address [showAutocomplete]="true" name="address" [(ngModel)]="employeeAddress"></app-address>

        <p class="large-header">{{ 'self-serve.payYourTeam.jobInformation' | translate }}</p>
        <app-segment-header title="self-serve.employment"></app-segment-header>
        <div class="responsive-grid">
            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{ 'self-serve.payYourTeam.employmentType' | translate }}</mat-label>
                <mat-select
                    required
                    #employmentType="ngModel"
                    name="employmentType"
                    placeholder="{{ 'self-serve.payYourTeam.selectAnEmploymentType' | translate }}"
                    [(ngModel)]="employee.employmentType"
                >
                    <mat-option *ngFor="let employmentType of employmentTypeValues" [value]="employmentType">{{
                        employmentTypeDisplay[employmentType] | translate | capitalize
                    }}</mat-option>
                </mat-select>

                <mat-error *ngIf="employmentType.invalid">{{ employmentType.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{
                    'forms.applicant-tracker.hire-flow.position' | appTranslate
                }}</mat-label>
                <mat-select
                    placeholder="{{ 'forms.applicant-tracker.hire-flow.selectAPosition' | appTranslate }}"
                    [(ngModel)]="employee.job"
                    #position="ngModel"
                    [compareWith]="isSameModel"
                    name="position"
                >
                    <mat-option [value]="null">-</mat-option>
                    <mat-option (click)="showCreateJobModal = true"
                        ><span class="add-option">{{
                            'forms.applicant-tracker.hire-flow.addNewPosition' | appTranslate
                        }}</span></mat-option
                    >
                    <mat-option *ngFor="let position of jobs" [value]="position">{{ position.title }}</mat-option>
                </mat-select>

                <mat-error *ngIf="position.invalid">{{ position.errors | formErrors }}</mat-error>
            </mat-form-field>
            <ui-date-picker
                [label]="'self-serve.payYourTeam.hireDate' | translate"
                [(ngModel)]="employee.hiredAt"
                [required]="true"
                #hiredAt="ngModel"
                name="hiredAt"
            >
            </ui-date-picker>
            <ui-date-picker
                [label]="'self-serve.payYourTeam.lastDayOfWork' | translate"
                [(ngModel)]="employee.lastDayOfWorkOn"
                [required]="true"
                #lastDayOfWorkOn="ngModel"
                name="lastDayOfWorkOn"
            >
            </ui-date-picker>
            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{ 'self-serve.payYourTeam.office' | translate }}</mat-label>
                <mat-select
                    [disabled]="!offices.length"
                    required
                    name="employeeOffice"
                    #employeeOffice="ngModel"
                    [(ngModel)]="employee.officeId"
                    [placeholder]="'self-serve.payYourTeam.selectAnOption' | translate"
                >
                    <mat-option *ngFor="let office of offices" [value]="office.id">{{ office.name }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.submitted && employeeOffice.invalid">{{
                    'self-serve.fieldRequired' | translate
                }}</mat-error>
            </mat-form-field>
        </div>
        <app-segment-header title="self-serve.termination"></app-segment-header>
        <div class="responsive-grid">
            <ui-date-picker
                [label]="'self-serve.payYourTeam.terminationDate' | translate"
                [(ngModel)]="employee.terminatedOn"
                [required]="true"
                #terminatedOn="ngModel"
                name="terminatedOn"
            >
            </ui-date-picker>
            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{ 'self-serve.payYourTeam.terminationType' | translate }}</mat-label>
                <mat-select
                    name="terminationReasonCode"
                    required
                    #terminationReasonCode="ngModel"
                    [(ngModel)]="employee.terminationReasonCode"
                >
                    <mat-option *ngFor="let tCode of terminationCodes | keyvalue" [value]="tCode.key">{{
                        tCode.value
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="terminationReasonCode.invalid">{{
                    terminationReasonCode.errors | formErrors
                }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.terminationReason' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    [(ngModel)]="employee.terminationComments"
                    name="terminationComments"
                    placeholder="{{ 'self-serve.payYourTeam.terminationReasonExamples' | translate }}"
                    #terminationComments="ngModel"
                />
                <mat-error *ngIf="terminationComments.invalid">{{ terminationComments.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <app-segment-header title="self-serve.payrollInformation"></app-segment-header>
        <div class="responsive-grid margin-bottom-4">
            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{ 'self-serve.payYourTeam.salaryFrequency' | translate }}</mat-label>
                <mat-select
                    name="salaryFrequency"
                    #salaryFrequency="ngModel"
                    placeholder="{{ 'self-serve.payYourTeam.notApplicable' | translate }}"
                    [(ngModel)]="salary.frequency"
                >
                    <mat-option *ngFor="let frequency of ['year', 'hour']" [value]="frequency">{{
                        'self-serve.' + frequency | translate
                    }}</mat-option>
                    <mat-option [value]="null">{{ 'self-serve.payYourTeam.notApplicable' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>

            <ng-container *ngIf="salary.frequency">
                <mat-form-field>
                    <mat-label>{{ salary.frequencyLabel | translate }}</mat-label>
                    <input
                        type="text"
                        matInput
                        [ngModel]="salary.rate"
                        (ngModelChange)="salary.rate = stripNonNumeric($event); resetCursorPosition()"
                        [textMask]="{ mask: currencyMask }"
                        [min]="0"
                        name="salary"
                        #salaryRate="ngModel"
                        required
                        [placeholder]="
                            'self-serve.payYourTeam.egAmount'
                                | translate: { amount: salary.frequency === 'hour' ? 30 : 45000 }
                        "
                    />

                    <mat-error *ngIf="salaryRate.invalid">{{ firstName.errors | formErrors }}</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ 'self-serve.payYourTeam.hoursPerWeek' | translate }}</mat-label>
                    <input
                        type="number"
                        [min]="0"
                        [max]="168"
                        placeholder="{{ 'self-serve.payYourTeam.eg40' | translate }}"
                        name="hoursPerWeek"
                        required
                        #hoursPerWeek="ngModel"
                        matInput
                        [(ngModel)]="salary.hoursPerWeek"
                    />

                    <mat-error *ngIf="hoursPerWeek.invalid">{{ hoursPerWeek.errors | formErrors }}</mat-error>
                </mat-form-field>

                <ui-date-picker
                    [label]="'self-serve.payYourTeam.compensationEffectiveDate' | translate"
                    [(ngModel)]="salary.effectiveAt"
                    [required]="true"
                    #compensationEffectiveDate="ngModel"
                    name="compensationEffectiveDate"
                >
                </ui-date-picker>
            </ng-container>
        </div>
    </ng-container>

    <div class="flex buttons justify-end">
        <ui-button type="primary" [submit]="true" [disabled]="isSaving">{{
            (sendInvite ? 'self-serve.payYourTeam.saveAndSendInvite' : 'save') | translate
        }}</ui-button>
    </div>
</form>

<ui-dialog
    [open]="showCreateJobModal"
    [form]="positionForm"
    size="small"
    (primaryButtonPressed)="onCreatePosition(newJob)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="clearPosition()"
    (closing)="clearPosition()"
    secondaryButtonLabel="cancel"
    header="{{ 'applicant-tracker.createNewPosition' | appTranslate }}"
>
    <form #positionForm="ngForm">
        <app-position-form *ngIf="showCreateJobModal" [position]="newJob"></app-position-form>
    </form>
</ui-dialog>
